define('punchout2go_landing_page_link_view.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('punchout2go_landing_page_link_view', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"p2go-landing-page-link-container\"><a class=\"p2go-landing-page-link\" href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? _nl_(depth0,"link") : depth0)) != null ? _nl_(stack1,"urlPath") : stack1), depth0))
    + "\" data-hashtag=\"#"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? _nl_(depth0,"link") : depth0)) != null ? _nl_(stack1,"urlPath") : stack1), depth0))
    + "\" data-touchpoint=\"home\" title=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? _nl_(depth0,"link") : depth0)) != null ? _nl_(stack1,"label") : stack1), depth0))
    + "\">"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? _nl_(depth0,"link") : depth0)) != null ? _nl_(stack1,"label") : stack1), depth0))
    + "</a></div> ";
},"useData":true}, 'extensions/NSeComm/Punchout2Go/2.0.0/', 'extensions/NSeComm/Punchout2Go/2.0.0/', Handlebars);
});